import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PreCancel from "./component";
import { getPlans } from "../plan/actions";
import { updateUserPlan } from "./actions";

const mapStateToProps = ({ funnelStep }) => ({ funnelStep });

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getPlansConnect: getPlans,
      updateUserPlanConnect: updateUserPlan,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(PreCancel);
